"use client";

import { useOrganizationBranding } from "@saas/organizations/hooks/use-organization-branding";
import { cn } from "@ui/lib";
import Image from "next/image";
import { useTheme } from "next-themes";
import { useIsClient } from "usehooks-ts";

export function Logo({ withLabel = true, className }: { className?: string; withLabel?: boolean }) {
  const { resolvedTheme } = useTheme();
  const isClient = useIsClient();
  const { brandingData } = useOrganizationBranding();

  // Use custom logo if branding is enabled and logoUrl is provided
  if (brandingData?.enabled && brandingData?.logoUrl) {
    // Use regular img tag for image-proxy URLs (which redirect to signed S3 URLs)
    // Next.js Image component doesn't handle redirects well
    if (brandingData.logoUrl.startsWith("/image-proxy/")) {
      return (
        <img
          src={brandingData.logoUrl}
          alt="Organization Logo"
          className={cn("text-primary", className)}
          width={1220}
          height={113}
          style={{ objectFit: "contain" }}
        />
      );
    }

    // For direct URLs, use Next.js Image component
    return (
      <Image
        src={brandingData.logoUrl}
        alt="Organization Logo"
        className={cn("text-primary", className)}
        width={1220}
        height={113}
        style={{ objectFit: "contain" }}
        priority
      />
    );
  }

  if (!withLabel) {
    return (
      <Image
        src="/images/brand/smarterdemo-mark.png"
        alt="SmarterDemo"
        className={cn("object-contain", className)}
        width={395}
        height={439}
        priority
      />
    );
  }

  return (
    <Image
      src={
        isClient && resolvedTheme === "dark"
          ? "/images/brand/smarterdemo-logo-dark.png"
          : "/images/brand/smarterdemo-logo.png"
      }
      alt="SmarterDemo"
      className={cn("object-contain", className)}
      width={1913}
      height={439}
      priority
    />
  );
}
